<template>
  <b-row :class="{ mobile: this.mobile, open: sidebarOpened }">
    <transition name="slide">
      <b-col
        md="3"
        lg="3"
        xl="2"
        v-if="!mobile || sidebarOpened"
        class="col-sidebar d-none d-md-block"
      >
        <div v-if="this.mobile" class="close-icon">
          <b-link @click="toggleSidebar()" variant="outline-secondary">
            <b-icon icon="x" scale="2.2" style="color: #333"
          /></b-link>
        </div>
        <steps-sidebar :sidebar-opened="sidebarOpened" :steps="steps" />
      </b-col>
    </transition>
    <b-col class="col-content px-4" md="9" lg="9" xl="10">
      <router-view />
      <b-button
        size="lg"
        variant="primary"
        :class="{ 'next-btn': true, relative: this.$route.name=='columnTypesWithConfig' }"
        @click="goToNext()"
      >
        {{ nextStep ? $t("continue") : $t("done") }}
      </b-button>
    </b-col>

    <div class="mobile-footer" v-if="mobile">
      <div class="d-flex">
        <div class="mr-auto">
          <b-link @click="toggleSidebar()" variant="outline-secondary">
            <span class="menu"></span
          ></b-link>
        </div>
        <div v-if="nextStep" class="mr-3 mb-1 align-self-center">
          <b-button variant="light" @click="goToNext()"
            >{{ this.nextStep.title }} <b-icon icon="chevron-right"
          /></b-button>
        </div>
      </div>
    </div>
  </b-row>
</template>


<script>
import StepsSidebar from "./StepsSideBar";

export default {
  data() {
    return {
      mobile: false,
      sidebarOpened: false,
      currentStep: null,
    };
  },
  components: {
    StepsSidebar,
  },
  created() {
    const mq = matchMedia("(max-width: 769px)");
    mq.onchange = (event) => (this.mobile = event.matches);
    this.mobile = mq.matches;

    this.$watch(
      () => this.$route,
      () => {
        this.sidebarOpened = false;
        this.currentStep = this.steps.find(
          (step) => step.route == this.$route.name
        );
      },
      { immediate: true }
    );
  },

  computed: {
    columnConfiguration() {
      if (this.$store.state.configurations.configuration !== null)
        return this.$store.state.configurations.configuration;
      return null;
    },
    columnType() {
      return this.$store.state.columnTypes.find((columnType) => {
        return columnType.id == this.columnConfiguration.columnType;
      });
    },
    steps() {
      if (!this.columnType) return [];

      const steps = [
        { route: "columnTypesWithConfig", title: this.$t("header.columnType") },
        { route: "jibCrane", title: this.$t("configuration.jibCrane") },
        {
          route: "electricalProtection",
          title: this.$t("bom.electricProtection"),
        },
        {
          route: "modulePlacements",
          title: this.$t("configuration.modulePlacements"),
        },
        { route: "summary", title: this.$t("configuration.summary") },
      ];
      return steps.filter(
        (step) => step.route != "jibCrane" || this.columnType.jibCrane || this.columnConfiguration.jibCrane
      );
    },
    nextStep() {
      const index = this.steps.findIndex(
        (step) => step.route == this.$route.name
      );
      return this.steps[index + 1] || null;
    },
  },

  methods: {
    goToNext() {
      var route = null;

      if (this.nextStep == null) {
        route = "shoppingCart";
      } else {
        route = this.nextStep.route;
      }
      this.$router.push({
        name: route,
        params: {
          projectId: this.$store.getters.projectNumber,
          configurationId: this.$store.getters.configurationIndex,
        },
      });
    },
    toggleSidebar() {
      this.sidebarOpened = !this.sidebarOpened;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-footer {
  position: fixed;
  bottom: 0;
  background: #fbfbfb;
  height: 50px;
  width: 100%;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}
.mobile.open .close-icon {
  position: absolute;
  right: 20px;
  margin-top: 20px;
  z-index: 999;
}
span.menu {
  display: inline-block;
  height: 30px;
  width: 30px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
  margin: 10px;
}
.col-sidebar {
  background: #fbfbfb;
  border-right: 1px solid #f0f0f0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
  min-width: 120px;
  padding: 0px;
}
.mobile .col-sidebar {
  position: fixed;
  width: 100%;
  max-width: 375px;
  display: block !important;
  z-index: 990;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 13px 0px;
}
.col-sidebar aside {
  position: fixed;
  padding: 0;
}
.col-content {
  overflow: auto;
  -webkit-overflow-scrolling: scroll;
  -webkit-overflow-scrolling: touch;
  height: calc(100vh - 60px);
  height: -o-calc(100% - 60px); /* opera */
  height: -webkit-calc(100% - 60px); /* google, safari */
  height: -moz-calc(100% - 60px); /* firefox */
}
.mobile .col-content {
  height: calc(100vh - 110px);
  height: -o-calc(100% - 110px); /* opera */
  height: -webkit-calc(100% - 110px); /* google, safari */
  height: -moz-calc(100% - 110px);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}

.slide-enter,
.slide-leave-to {
  margin-right: calc(var(--width) * -1);
  transform: translateX(-100%);
  opacity: 0.6;
}
</style>
